import React, { useEffect, useState } from "react";
import apiConstants from "../../constans/apiConstants";
import {
    httpRequestGet,
    indianCurrencyFormat,
    toaster,
    } from "../../utils/utils";
    import { useDispatch, useSelector } from "react-redux";
    import PaymentOptions from "../../components/PaymentOptions";
    import OldPaymentOption from "../../components/PaymentOptions/OldPaymentOption";
    import {
    payment_check,
    sendEnach,
    checkIFSC,
    neftPayment,
    } from "../../store/actions/paymentActions";
    import * as actionType from "../../store/actionTypes";
    import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";

    import Enach from "../../components/enach";
import { getDCRDetails } from "../../store/actions/paymentPatchingActions";

    const D2cPayment = () => {
    const initialState = {
        accountNumber: "",
        accHolderName: "",
        accountType: "SAVING",
        ifscCode: "",
        bankName: "",
        branchName: "",
    };

    const [proposalNumber, setProposal] = useState({
        proposal: "",
        error: false,
    });

    const [neftDetail, setNeftDetail] = useState(initialState);

    const [payState, setPayState] = useState(true);

    const [neftPopup, setneftPopup] = useState(false);

    const { proposalDetails, ifsc, eligibilty } = useSelector((state) => ({
        proposalDetails: state.paymentReducer.proposalDetails,
        ifsc: state.paymentReducer.ifsc,
        eligibilty: state.paymentReducer.eligibilty,
    }));

    const dispatch = useDispatch();
    const searchItem = () => {
        dispatch(payment_check(proposalNumber));
    };
    const inputHandler = (e) => {
        setProposal({ proposal: e.target.value, error: false });
    };
    const sendENach = () => {
        let data = {
        proposalNumber: proposalNumber.proposal,
        paymentMode: "E_MANDATE",
        };
        dispatch(
        sendEnach(data, (resp) => {
            toaster("success", "e-NACH link successfully sent to customer");
        })
        );
    };

    const openNeftPopup = () => {
        setneftPopup(true);
        if (proposalDetails !== "") {
        setNeftDetail({
            accHolderName:
            proposalDetails?.paymentDetails?.neftDetails?.accHolderName || "",
            accountNumber:
            proposalDetails?.paymentDetails?.neftDetails?.accountNumber || "",
            accountType:
            proposalDetails?.paymentDetails?.neftDetails?.accountType || "SAVING",
            bankName: proposalDetails?.paymentDetails?.neftDetails?.bankName || "",
            branchName:
            proposalDetails?.paymentDetails?.neftDetails?.branchName || "",
            ifscCode: proposalDetails?.paymentDetails?.neftDetails?.ifscCode || "",
        });
        } else {
        setNeftDetail(initialState);
        }
        setPayState(true);
    };
    const closeForm = () => {
        setneftPopup(false);
        setNeftDetail(initialState);
        setPayState(true);
    };

    const handleChange = (name, value) => {
        let getData = { ...neftDetail };
        let flag = false;

        if (name === "ifscCode" && value) {
        if (
            value.length === 11 &&
            /([A-Z]){4}0([A-Z0-9]){6}$/.test(value.toUpperCase())
        ) {
            dispatch(
            checkIFSC(value.toUpperCase(), () => {
                getData = {
                ...getData,
                bankName: "",
                branchName: "",
                };
                setPayState(false);
                setNeftDetail(getData);
                flag = true;
            })
            );
        }
        }
        if (flag) return;
        getData[name] = value;
        setNeftDetail(getData);
    };

    useEffect(() => {
        if (
        neftDetail.accountNumber !== "" &&
        neftDetail.accHolderName !== "" &&
        neftDetail.ifscCode !== "" &&
        neftDetail.bankName !== "" &&
        neftDetail.branchName !== "" &&
        neftDetail.accountType !== ""
        ) {
        setPayState(false);
        } else {
        setPayState(true);
        }
    }, [neftDetail]);

    useEffect(() => {
        const getdata = { ...neftDetail };
        if (ifsc) {
        getdata.bankName = ifsc.bank;
        getdata.branchName = ifsc.branch;
        setNeftDetail(getdata);
        }
    }, [ifsc]);

    const saveNeftDetails = () => {
        dispatch(neftPayment(neftDetail, proposalNumber.proposal));
        setneftPopup(false);
    };

    const getDCRData = () => {
      if (!proposalNumber.proposal) {
        toaster('error', 'Please enter proposal number');
        return;
      }
      dispatch(getDCRDetails(proposalNumber.proposal));
    };

    return (
        <>
        <div className="downloads_comp logs_comp d2cPayment">
            {/* <h1>JSON request tracker</h1> */}
            <div>Enter proposal number</div>
            <div className="tabSelection">
            <div className="input-fields-wrapper">
                <input
                onChange={(e) => inputHandler(e)}
                value={proposalNumber.proposal}
                className={`input-field`}
                type="text"
                placeholder="Enter Proposal Number"
                name="proposal"
                />
            </div>
            {proposalNumber.error && (
                <div className="error">Please Enter Number</div>
            )}
            <button className="searchbt" onClick={searchItem}>
                Search
            </button>
            <button className="searchbt dcrbtn" onClick={getDCRData}>
                Get DCR Call
            </button>
            </div>
        </div>
        <div className="proposal-status">
            {proposalNumber.proposal && eligibilty && eligibilty.message}
        </div>
        {eligibilty && eligibilty.body && proposalNumber.proposal && (
            <div>
                    {window.envType === "DEV" ?
                        <PaymentOptions
                            neftPopup={neftPopup}
                            proposalNumber={proposalNumber.proposal}
                            search={searchItem}
                        /> :
                        <OldPaymentOption
                            neftPopup={neftPopup}
                            proposalNumber={proposalNumber.proposal}
                            search={searchItem}
                        />
                    }

            <div className="enach-row-container">
                <div className="enach-labels">
                <span>Neft Details</span>
                </div>
                <button className="btn-pay" onClick={openNeftPopup}>
                Edit
                </button>
            </div>

            {neftPopup && (
                <MobilePopUp onClose={closeForm} heading={`Fill Neft Details`}>
                <div className="neft-form">
                    <div className="form-halfs">
                    <div className=" input-fields-wrapper">
                        <label>Bank Account No.</label>
                        <input
                        name="accountNumber"
                        className="input-field"
                        type="number"
                        onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                        }
                        value={neftDetail.accountNumber}
                        placeholder="Enter"
                        maxLength="20"
                        />
                    </div>
                    <div className=" input-fields-wrapper">
                        <label>Account Holder Name</label>
                        <input
                        name="accHolderName"
                        className="input-field"
                        type="text"
                        onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                        }
                        value={neftDetail.accHolderName}
                        placeholder="Enter"
                        />
                    </div>
                    </div>
                    <div className="form-halfs">
                    <div className="input-fields-wrapper">
                        <label>Account Type</label>
                        <select
                        name="accountType"
                        className="input-field"
                        type="number"
                        value={neftDetail.accountType}
                        onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                        }
                        placeholder="Enter"
                        >
                        <option value="SAVING">Savings</option>
                        <option value="CURRENT">Current</option>
                        <option value="NRE">Nre</option>
                        <option value="NRO">Nro</option>
                        </select>
                    </div>
                    <div className="input-fields-wrapper">
                        <label>IFSC Code</label>
                        <input
                        className="input-field"
                        type="text"
                        name="ifscCode"
                        value={neftDetail.ifscCode}
                        onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                        }
                        placeholder="Enter"
                        maxLength="11"
                        />
                    </div>
                    </div>

                    <div className="input-fields-wrapper">
                    <label>Bank Name</label>
                    <input
                        className="input-field"
                        type="text"
                        name="bankName"
                        disabled
                        value={neftDetail.bankName}
                        placeholder="Enter"
                    />
                    </div>
                    <div className="input-fields-wrapper">
                    <label>Branch Name</label>
                    <input
                        className="input-field"
                        type="text"
                        name="branchName"
                        disabled
                        value={neftDetail.branchName}
                        placeholder="Enter"
                    />
                    </div>
                    <button
                    className="btn-pay"
                    onClick={saveNeftDetails}
                    disabled={payState}
                    >
                    Save
                    </button>
                </div>
                </MobilePopUp>
            )}
            {/* <Enach
                sendEnach={sendENach}
                enachDetails={proposalDetails.paymentDetails?.renewal}
            /> */}
            </div>
        )}
        </>
    );
};

export default D2cPayment;
